import React from 'react';
import Icon from '../../../components/AppIcon';

const FeatureHighlights = () => {
  const features = [
    {
      icon: 'FileText',
      title: 'PDF to Flipbook',
      description: 'Transform static PDFs into engaging interactive flipbook catalogs in minutes'
    },
    {
      icon: 'MousePointerClick',
      title: 'Interactive Hotspots',
      description: 'Add clickable links, buttons, and buy actions with drag-and-drop simplicity'
    },
    {
      icon: 'ShoppingCart',
      title: 'VTEX Integration',
      description: 'Seamlessly connect product SKUs to your e-commerce storefront'
    },
    {
      icon: 'Code2',
      title: 'Easy Embedding',
      description: 'Embed catalogs anywhere with JavaScript or iframe code snippets'
    },
    {
      icon: 'BarChart3',
      title: 'Advanced Analytics',
      description: 'Track views, engagement, and conversions with detailed insights'
    },
    {
      icon: 'Users',
      title: 'Team Collaboration',
      description: 'Manage multiple users with role-based access and permissions'
    }
  ];

  return (
    <div className="space-y-6 md:space-y-8">
      <div>
        <h3 className="text-xl md:text-2xl font-semibold text-foreground mb-2">
          Everything you need to create stunning digital catalogs
        </h3>
        <p className="text-sm md:text-base text-muted-foreground">
          Join thousands of businesses transforming their product catalogs into interactive experiences
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6">
        {features?.map((feature, index) => (
          <div
            key={index}
            className="flex items-start p-4 md:p-5 rounded-lg bg-card border border-border hover:border-accent/50 transition-all"
          >
            <div className="flex-shrink-0 w-10 h-10 md:w-12 md:h-12 rounded-lg bg-accent/10 flex items-center justify-center">
              <Icon name={feature?.icon} size={20} className="text-accent" />
            </div>
            <div className="ml-3 md:ml-4">
              <h4 className="text-sm md:text-base font-semibold text-foreground mb-1">
                {feature?.title}
              </h4>
              <p className="text-xs md:text-sm text-muted-foreground leading-relaxed">
                {feature?.description}
              </p>
            </div>
          </div>
        ))}
      </div>
      <div className="flex flex-wrap items-center gap-4 md:gap-6 pt-4 border-t border-border">
        <div className="flex items-center">
          <Icon name="Shield" size={20} className="text-success" />
          <span className="ml-2 text-xs md:text-sm text-muted-foreground">SSL Secured</span>
        </div>
        <div className="flex items-center">
          <Icon name="Lock" size={20} className="text-success" />
          <span className="ml-2 text-xs md:text-sm text-muted-foreground">GDPR Compliant</span>
        </div>
        <div className="flex items-center">
          <Icon name="CheckCircle" size={20} className="text-success" />
          <span className="ml-2 text-xs md:text-sm text-muted-foreground">99.9% Uptime</span>
        </div>
      </div>
    </div>
  );
};

export default FeatureHighlights;